import { Title } from '../../basic/help/title';
import { Image } from '../../basic/help/image';
import { ProcedureFormat } from '../../basic/help/procedureFormat';
import { Step } from  '../../basic/help/step';
import { Text } from '../../basic/help/text';
import RegisterExecuteKeyImg1 from '../../../img/manual/registerExecuteKey/registerExecuteKeyImg1.svg';
import RegisterExecuteKeyImg2 from '../../../img/manual/registerExecuteKey/registerExecuteKeyImg2.svg';

export const RegisterExecuteKey = () => {
  return (
    <div>
      <Title>execute-Keyの登録</Title>
      <Text>
        execute-Keyは、RICOH Chatbot ServiceでAPI連携を行う際に必要となるパラメータです。
      </Text>
      <ProcedureFormat>
        <Step>実行したいアプリの[設定]ボタンをクリックします。</Step>
        <Image src={RegisterExecuteKeyImg1} alt="registerExecuteKey1" width={60} />
        <Step>execute-Key右のコピーボタンでコピーしてご利用ください。</Step>
        <Image src={RegisterExecuteKeyImg2} alt="registerExecuteKey2" width={60} />
      </ProcedureFormat>
    </div>
  );
};
